module.exports = __webpack_public_path__ + "img/✅.765fa31c.svg";